export default __webpack_public_path__ + "static/media/QR-Phat.8b2fd1f1.png";